import noUiSlider from 'nouislider';

document.addEventListener('DOMContentLoaded', () => {
  const filterFlats = (container) => {
    const status = container.querySelector('select[name="status"]').value;
    const floor = container.querySelector('select[name="floor"]').value;
    const areaSlider = container.querySelector('.slider');
    const areaMin = areaSlider.noUiSlider.get()[0];
    const areaMax = areaSlider.noUiSlider.get()[1];

    const flatsList = container.querySelectorAll('.flats-table-row');
    const noResults = container.querySelector('.flats-table-no-results');

    let visibleFlats = 0;

    flatsList.forEach((flat) => {
      const flatFloor = flat.getAttribute('data-floor');
      const flatStatus = flat.getAttribute('data-status');
      const flatArea = Number(flat.getAttribute('data-area'));

      const matchesStatus = status === 'all' || flatStatus === status;
      const matchesFloor = floor === 'all' || flatFloor === floor;
      const matchesArea = (areaMin === '' || flatArea >= areaMin) && (areaMax === '' || flatArea <= areaMax);

      if (matchesStatus && matchesFloor && matchesArea) {
        flat.style.display = 'grid';
        visibleFlats++;
      } else {
        flat.style.display = 'none';
      }
    });

    if (visibleFlats === 0) {
      noResults.style.display = 'block';
    } else {
      noResults.style.display = 'none';
    }
  };

  const flatListBlocks = document.querySelectorAll('.wp-block-mitery-blocks-flats-list');
  flatListBlocks.forEach((block) => {
    const filtersWrapper = block.querySelector('.flats-table-filters');
    if (filtersWrapper) {
      const statusSelect = filtersWrapper.querySelector('select[name="status"]');

      new Choices(statusSelect, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: '',
        callbackOnCreateTemplates: function (template) {
          return {
            item: (classNames, data) => {
              return template(`
                <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : ''} ${data.selected ? classNames.selectedState : ''}" data-item data-id="${data.id}" data-value="${data.value}" ${data.active ? 'aria-selected="true"' : ''} ${data.disabled ? 'aria-disabled="true"' : ''}>
                  Status: ${data.label}
                </div>
              `);
            }
          };
        }
      });

      const floorSelect = filtersWrapper.querySelector('select[name="floor"]');
      new Choices(floorSelect, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: '',
        callbackOnCreateTemplates: function (template) {
          return {
            item: (classNames, data) => {
              return template(`
                <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : ''} ${data.selected ? classNames.selectedState : ''}" data-item data-id="${data.id}" data-value="${data.value}" ${data.active ? 'aria-selected="true"' : ''} ${data.disabled ? 'aria-disabled="true"' : ''}>
                  ${data.label}
                </div>
              `);
            }
          };
        }
      });

      const areaSlider = filtersWrapper.querySelector('.slider');
      const areaMin = Number(areaSlider.dataset.areaMin);
      const areaMax = Number(areaSlider.dataset.areaMax);
      noUiSlider.create(areaSlider, {
        start: [areaMin, areaMax],
        connect: true,
        step: 1,
        range: {
          min: areaMin,
          max: areaMax
        }
      });
      const areaRangeMin = areaSlider.parentNode.querySelector('.slider-range-min');
      const areaRangeMax = areaSlider.parentNode.querySelector('.slider-range-max');

      areaSlider.noUiSlider.on('update', (values) => {
        filterFlats(block);
        areaRangeMin.textContent = Math.round(values[0]) + ' m²';
        areaRangeMax.textContent = Math.round(values[1]) + ' m²';
      });

      statusSelect.addEventListener('change', () => {
        filterFlats(block);
      });
      floorSelect.addEventListener('change', () => {
        filterFlats(block);
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const closeModal = (e) => {
    e.preventDefault();

    const flatModal = document.querySelector('.flat-modal');
    if (flatModal) {
      flatModal.classList.remove('is-open');
      setTimeout(() => {
        flatModal.remove();
        document.body.classList.remove('modal-open');
      }, 300);
    }
  };

  const openModal = (content) => {
    const modal = document.createElement('div');
    const modalContent = document.createElement('div');
    const modalInner = document.createElement('div');
    const modalClose = document.createElement('button');
    modal.classList.add('flat-modal');
    modalContent.classList.add('flat-modal-content');
    modalInner.classList.add('flat-modal-inner');
    modalClose.classList.add('flat-modal-close');
    modalClose.addEventListener('click', closeModal);

    modal.appendChild(modalContent);
    modalContent.appendChild(modalInner);
    modalInner.innerHTML = content;
    modalInner.appendChild(modalClose);

    document.body.appendChild(modal);
    document.body.classList.add('modal-open');
    setTimeout(() => {
      modal.classList.add('is-open');
    }, 100);
  };

  const detailsLinks = document.querySelectorAll('.wp-block-mitery-blocks-flats-list .flat-detail-details-link');

  detailsLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      fetch(link.href)
        .then((response) => response.text())
        .then((html) => {
          const newBody = document.createElement('div');
          newBody.innerHTML = html;
          const singleFlat = newBody.querySelector('.single-flat');
          openModal(singleFlat.outerHTML);
        });
    });
  });
});
